var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.666667 955.733333c-66.030933 0-102.4-36.369067-102.4-102.4V341.333333v-0.0512a17.015467 17.015467 0 0 1 5.000533-12.014933l256-256c1.6384-1.6384 3.5328-2.8672 5.546667-3.703467A16.708267 16.708267 0 0 1 341.282133 68.266667H682.666667c66.030933 0 102.4 36.369067 102.4 102.4v314.043733l166.826666 175.9744a17.066667 17.066667 0 0 1 0 23.5008l-166.894933 176.0256c-2.577067 59.1872-36.488533 92.8768-95.624533 95.505067L170.666667 955.733333zM102.4 358.4v494.933333c0 47.223467 21.0432 68.266667 68.266667 68.266667h517.973333c41.454933-1.8432 60.893867-21.504 62.3104-63.709867L750.933333 853.435733V774.826667h-152.746666a17.066667 17.066667 0 0 1-17.066667-17.066667v-170.666667a17.066667 17.066667 0 0 1 17.066667-17.066666H750.933333v-78.4896V170.666667c0-47.223467-21.0432-68.266667-68.266666-68.266667H358.4v238.933333a17.066667 17.066667 0 0 1-17.066667 17.066667H102.4z m512.853333 382.293333H768a17.066667 17.066667 0 0 1 17.066667 17.066667v52.770133l130.935466-138.103466L785.066667 534.3232V587.093333a17.066667 17.066667 0 0 1-17.066667 17.066667h-152.746667v136.533333zM126.532267 324.266667H324.266667V126.532267L126.532267 324.266667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFile);
export default __webpack_public_path__ + "static/media/sendFile.9cb73faaa4e8edfc0b79e293b9ba7803.svg";
export { ForwardRef as ReactComponent };